import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from "@env/environment";
@Injectable()
export class LikedinService {
 private userDetails: any = {};
 private linkedInScope: string;
  constructor(private httpClient: HttpClient) { }
   getLinkedInUserDetails(code: String) {
   this.linkedInScope = environment.LINKEDIN_SCOPE;
   return this.httpClient.post(`users/linkedin?code=${code}`, null);
   }
   setUserDetails(data) {
   this.userDetails = data;
   }
   getUserDetails() {
     return this.userDetails;
   }
   resetUserDetails() {
    this.userDetails = {};
   }
}



// WEBPACK FOOTER //
// ./src/app/likedin.service.ts